import { Button } from '@warp-ds/react';
import styles from './QasaPlatformSelectorButton.module.css';

type Props = {
    loading?: boolean;
    onClick?: () => void;
    href?: string;
    className?: string;
};

export const QasaPlatformSelectorButton = ({
    loading = false,
    onClick,
    href = '/travel-api/lotr/qasa/create-listing-landing',
    className = '',
}: Props) => (
    <Button
        className={`flex items-center justify-center gap-8 ${className} ${styles.qasaButton}`}
        href={href}
        fullWidth
        primary={!loading}
        loading={loading}
        onClick={onClick}>
        Lei ut på qasa.com
    </Button>
);
